export const messages = {
  en: {
    myHousekeepingDispatch: {
      searchCondition: 'Search Condition',
      workOrderNumber: 'Work Order Number',
      applicant: 'Applicant',
      contactNumber: 'Contact Number',
      status: 'Status',
      search: 'Search',
      reset: 'Reset',
      more: 'More',
      hide: 'Hide',
      serviceName: 'Service Name',
      orderNumber: 'Order Number',
      contactWay: 'Contact Way',
      appointmentTime: 'Appointment Time',
      operation: 'Operation',
      detail: 'Detail',
      completedServices: 'Completed Services'
    }
  },
  zh: {
    myHousekeepingDispatch: {
      searchCondition: '查询条件',
      workOrderNumber: '工单编号',
      applicant: '申请人',
      contactNumber: '联系电话',
      status: '状态',
      search: '查询',
      reset: '重置',
      more: '更多',
      hide: '隐藏',
      serviceName: '服务名称',
      orderNumber: '订单编号',
      contactWay: '联系方式',
      appointmentTime: '预约时间',
      operation: '操作',
      detail: '详情',
      completedServices: '服务已办'
    }
  }
}